import * as moment from 'moment'
import { OrderStatusIdentifier, PaymentSummary } from './enums/order-enums'

export const removeNamespace = (namespace, types) => {
  const typeKeys = Object.keys(types)
  return Object.values(types).reduce((typeObj, typeValue, j) => {
    const typeObjectKeys = Object.keys(typeValue)
    typeObj[typeKeys[j]] = Object.values(typeValue).reduce((obj, v, k) => {
      obj[typeObjectKeys[k]] = v.replace(namespace + '/', '')
      return obj
    }, {})
    return typeObj
  }, {})
}

export const fillArrayTo = (i, startFrom = 0, zeroBase = false) => {
  const diff = i - startFrom
  return new Array(diff)
    .fill(null)
    .map((v, i) => {
      const val = (!zeroBase) ? i + 1 : i
      return startFrom + val
    })
}

export const formatDate = (date, format) => {
  return moment(date).format(format)
}

export const randomIntFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export const getOrderStatusColor = (orderStatusId) => {
  const orangeStatuses = [
    OrderStatusIdentifier.Processing,
    OrderStatusIdentifier.Fulfilled,
    OrderStatusIdentifier.ReadyToShip,
    OrderStatusIdentifier.ReadyForPickup,
    OrderStatusIdentifier.CancelRequested
  ]
  const greenStatuses = [
    OrderStatusIdentifier.Complete
  ]

  if (orangeStatuses.includes(orderStatusId)) {
    return 'error'
  }
  if (greenStatuses.includes(orderStatusId)) {
    return 'accent'
  }
  return 'gray'
}

export const getPaymentSummaryColor = (paymentSummary) => {
  switch (paymentSummary) {
  case PaymentSummary.PartiallyPaid:
    return 'error'
  case PaymentSummary.Paid:
    return 'accent'
  default:
    return 'gray'
  }
}

export const downloadFile = (data, filename) => {
  if (!data) {
    return
  }
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
}

export const createSelectFromEnum = (e) => {
  return Object.keys(e).map(x => ({
    text: x.replace(/([A-Z,1-9])/g, ' $1').trim(),
    value: e[x]
  }))
}

export const loadScript = (url, callback) => {
  let e = document.createElement('script')
  e.src = url
  e.type = 'text/javascript'
  document.getElementsByTagName('head')[0].appendChild(e)
  e.addEventListener('load', callback)
}

export const extractChapterException = (err) => {
  if (err) {
    if (err.isChapterException) {
      return err
    }
    if (err.response && err.response.data && err.response.data.isChapterException) {
      return err.response.data
    }
  }
  return null
}

export const TenantNameMap = Object.freeze({
  1: 'Baker Book House',
  2: 'Baker Academic'
})
